import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { searchCustomers } from 'interfaces/customer';
import CustomerSearchBar from 'components/fields/CustomerSearchBar';
import { MdArrowForward } from 'react-icons/md';

interface CustomerSelectionProps {
    onCustomerSelected: (customer: any) => void;
    isProcessing: boolean;
}

const CustomerSelection = ({ onCustomerSelected, isProcessing }: CustomerSelectionProps) => {
    const [customers, setCustomers] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        initCustomers('');
    }, []);

    const initCustomers = async (search: string) => {
        setIsLoading(true);
        try {
            const res = await searchCustomers(search);
            if (res && res.data) {
                const newCustomers = res.data.map((customer: any) => ({
                    ...customer,
                    company: customer.displayName || customer.company,
                }));
                setCustomers(newCustomers);
            }
        } catch (error) {
            console.error('Error loading customers:', error);
            toast.error('Erreur lors du chargement des clients');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearchChange = (value: string) => {
        setSearchValue(value);
        if (value.length >= 2 || value.length === 0) {
            initCustomers(value);
        }
    };

    const handleCustomerClick = (customer: any) => {
        setSelectedCustomer(customer);
    };

    const handleConfirm = () => {
        if (selectedCustomer) {
            onCustomerSelected(selectedCustomer);
        }
    };

    return (
        <div className="flex flex-col gap-4">
            <CustomerSearchBar
                options={customers}
                displayKey="company"
                onSelect={handleCustomerClick}
                onSearch={handleSearchChange}
                value={selectedCustomer?._id}
                isLoading={isLoading}
                canCreate={false}
            />

            {selectedCustomer && (
                <div className="mt-4 rounded-lg border-2 border-toola-500 bg-toola-50 p-4 dark:bg-navy-800">
                    <h3 className="mb-2 font-bold text-navy-700 dark:text-white">
                        Client sélectionné
                    </h3>
                    <div className="text-sm text-gray-600 dark:text-gray-400">
                        <p className="font-semibold">{selectedCustomer.company || selectedCustomer.displayName}</p>
                        {selectedCustomer.email && <p>Email: {selectedCustomer.email}</p>}
                        {selectedCustomer.phone && <p>Téléphone: {selectedCustomer.phone}</p>}
                        {selectedCustomer.address && (
                            <p>Adresse: {selectedCustomer.address}, {selectedCustomer.city} {selectedCustomer.zipCode}</p>
                        )}
                    </div>
                </div>
            )}

            <div className="mt-6 flex justify-end">
                <button
                    onClick={handleConfirm}
                    disabled={!selectedCustomer || isProcessing}
                    className="flex items-center gap-2 rounded-xl bg-toola-500 px-6 py-3 text-base font-medium text-white transition duration-200 hover:bg-toola-600 active:bg-toola-700 disabled:cursor-not-allowed disabled:opacity-50"
                >
                    Continuer
                    <MdArrowForward className="h-5 w-5" />
                </button>
            </div>

        </div>
    );
};

export default CustomerSelection;
